import { render } from "./Home.vue?vue&type=template&id=f5b19dae&scoped=true&bindings={\"isLoaded\":\"setup\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=f5b19dae&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-f5b19dae"

export default script